import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const ArrowDown = ({ color, size = '10', height = '5.7' }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={height}
      color={color || 'currentColor'}
      viewBox="0 0 10 6"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.853591L5 5.85359L0 0.853607L0.707108 0.1465L5 4.43938L9.29289 0.146484L10 0.853591Z"
        fill="#404040"
      />
    </StyledSvg>
  );
};
